import Model  from '@/util/models';

export default class Kompetisi extends Model { 
    backend = '/main/dashboard/'; 
       
    kompetisis(params){
        return this.api.get(this.backend + 'kompetisis', params);
    }
    
    kompetisi(params){
        return this.api.get(this.backend + 'kompetisi', params);
    }
    
    areas(params){
        return this.api.get(this.backend + 'areas', params);
    }
    
    dapils(params){
        return this.api.get(this.backend + 'dapils', params);
    }    
    
    calegs(params){
        return this.api.get(this.backend + 'calegs', params);
    } 
        
    
}

